<template>
    <section class="select-trim">
        <div class="configurator__container container">
            <StepBar step-name="Select your trim level" :step="3" :steps="7"/>

            <div class="configurator__flex-container">
                <div class="configurator__flex-left">
                    <Navigation
                        :go-to-step="{ name: 'select-fuel', params: { brand: brand, urlModel: urlModel }, query: { id: configuratorId } }"/>

                    <ImageGallery/>
                </div>

                <div class="configurator__flex-right">
                    <Card :title="model.model_title" description="Choose your trim level:" :price="cheapestPrice">
                        <LoadingSpinner v-if="loading"></LoadingSpinner>
                        <RadioButton v-else v-model="selectedTrim" id-key="id" value-key="value" price-key="price" :options="trims" :show-prices="true" :has-info="true" @info-clicked="defineInfoAndOpenModal" />
                    </Card>

                    <div ref="continueButton" class="configurator__continue-btn-container">
                        <button class="btn btn--primary btn--min-width btn--full-width-xs" :class="{'btn--disabled': !trimChoice}" :disbled="!trimChoice" @click="nextStep">Continue</button>
                    </div>

                    <SaveConfiguration/>
                </div>
            </div>
        </div>

        <OptionInfoModal v-if="optionInfo" :open="isModalVisible" :info="optionInfo" @close-option-info-modal="isModalVisible = false"/>
    </section>
</template>

<script>
import EventObject from "../../modules/tracking/EventObject";
import {mapState} from "vuex";
import scrollToElement from "../modules/scrollToElement";
import OptionInfoModal from '../components/OptionInfoModal.vue';

export default {
    components: {
        OptionInfoModal
    },
    props: {
        brand: {
            type: String,
            required: true
        },
        urlModel: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            optionInfo: null,
            isModalVisible: false,
            loading: true,
        }
    },
    methods: {
        defineInfoAndOpenModal: function (option) {
            this.optionInfo = option;
            this.isModalVisible = true;
        },
        nextStep: function () {
            if (!this.trimChoice) {
                return;
            }

            new EventObject("New Car - Configurator", "Next Step", "Clicked to Step 4 of 7: Select engine").dispatch();

            this.$router.push({
                name: 'select-engine',
                params: {brand: this.brand, urlModel: this.urlModel},
                query: {id: this.configuratorId}
            });
        },
    },
    created() {
        this.$store.dispatch('getTrims')
            .then(() => {
                document.title = `${this.model.model_title} ${this.fuelTypeChoice} | Configure My New ${this.manufacturer} Car`

                this.$store.commit('setSelectedVehiclePrice', this.cheapestPrice);

                if (this.trims.length == 1) {
                    this.selectedTrim = this.trims[0].id;
                }

                this.loading = false;
            });
    },
    computed: {
        ...mapState(['availableTrims', 'model', 'trimChoice', 'configuratorId', 'fuelTypeChoice', 'manufacturer']),
        trims() {
            return this.availableTrims.map(trim => {
                return {
                    id: trim.trim,
                    value: trim.trim,
                    price: trim.newVehicle.pricing_display_price - this.cheapestPrice,
                    info: trim.bestSpec,
                    modelYear: trim.model_year
                }
            });
        },

        selectedTrim: {
            get: function () {
                return this.$store.state.trimChoice;
            },
            set: function (selectedTrimId) {
                for (let index = 0; index < this.trims.length; index++) {
                    const selectedTrim = this.trims[index];
                    if (selectedTrim.id == selectedTrimId) {
                        this.$store.commit('setTrimChoiceId', selectedTrim.info[0].new_vehicles_trim_id);
                        this.$store.commit('setTrimChoice', selectedTrim.id);
                        this.$store.commit('setTrimYear', selectedTrim.modelYear);
                        // Also update the data used for the ImageGallery now
                        this.availableTrims.forEach(element => {
                            if (element.trim !== selectedTrim.id) {
                                return;
                            }
                            this.$store.commit('setPaintOptions', element.newVehicle.new_vehicle_paint_options);
                        });

                        this.$store.commit('setSelectedVehiclePrice', selectedTrim.price + this.cheapestPrice);
                        scrollToElement(this.$refs['continueButton']);
                        return;
                    }
                }
            },
        },

        cheapestPrice() {
            return Math.min(...this.availableTrims.map((trim) => trim.newVehicle.pricing_display_price))
        }
    }
}
</script>